import React from "react";
import Background from "@/components/Background";
import Logo from "@/components/Logo";
import Hero from "@/components/Hero";
import UpcomingVotes from "@/components/UpcomingVotes";
import Footer from "@/components/Footer";

const Landing = () => {
    return (
        <main
            data-testid="landing-page"
            className="relative min-h-screen overflow-hidden"
            style={{ backgroundColor: "var(--plenum-bg)" }}
        >
            <Background />

            <div className="relative z-10">
                <header
                    className="w-full"
                    data-testid="top-bar"
                >
                    <div className="max-w-[1180px] mx-auto px-6 sm:px-10 lg:px-14 h-[96px] sm:h-[112px] flex items-center justify-center">
                        <Logo />
                    </div>
                </header>

                <Hero />
                <UpcomingVotes />
                <Footer />
            </div>
        </main>
    );
};

export default Landing;
